import { useEffect } from "react";

interface ThanksProps {
  setIsOpen: (open: boolean) => void;
}

const Thanks: React.FC<ThanksProps> = ({ setIsOpen }) => {
  useEffect(() => {
    setTimeout(() => {
      setIsOpen(false);
    }, 3000);
  }, [setIsOpen]);

  return (
    <div className="flex justify-center items-end h-full pb-10">
      <div className="max-w-xs">
        <h1 className="text-3xl font-bold text-center text-white">
          Thank you!
        </h1>
        <p className="mt-2 text-base px-8 text-center text-white">
          You’ll receive a confirmation email as soon as your hint has been
          sent.
        </p>
      </div>
    </div>
  );
};

export default Thanks;
